import { render } from "./view-more-button.vue?vue&type=template&id=c2fc48f2&scoped=true"
import script from "./view-more-button.vue?vue&type=script&lang=js"
export * from "./view-more-button.vue?vue&type=script&lang=js"

import "./view-more-button.vue?vue&type=style&index=0&id=c2fc48f2&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fc48f2"]])

export default __exports__